/* TSH Five Pillars: approved motion with Shopify section lifecycle.
   All asset URLs and user-visible control labels come from Liquid data settings. */
(() => {
  if (window.TSHPillarsPage) { window.TSHPillarsPage.scan(document); return; }
  const roots = new Map();
  const pauseState = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const kinds = ['breath','foundation','bounce','control','flow'];
  let preferenceTimer;
  let lastReduced = reduced.matches;

  function bind(root) {
    if (roots.has(root)) return;
    const key = root.dataset.sectionId;
    const toggle = root.querySelector('.tsh-pp-motion-toggle');
    let paused = pauseState.get(key) || false;
    const controllers = [];
    const enabled = root.dataset.ppEnabled === 'true';
    if (enabled) root.querySelectorAll('[data-pp-motion]').forEach(stage => {
      const kind = stage.dataset.ppMotion;
      if (!kinds.includes(kind)) return;
      const urls = ['ppBase','ppBody','ppAccent'].map(name => stage.dataset[name]);
      if (urls.some(url => !url)) return;
      const canvas = document.createElement('canvas');
      canvas.width = 660; canvas.height = 660;
      canvas.setAttribute('aria-hidden','true');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      stage.append(canvas);
      let layers, pending, raf, active = false, visible = false, generation = 0, disposed = false;
      const load = () => pending ||= Promise.all(urls.map(url => new Promise((resolve,reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = url;
      }))).then(values => layers = values);
      const stop = () => {
        active = false; generation++; cancelAnimationFrame(raf);
        stage.classList.remove('is-playing'); stage.dataset.animating = 'false';
      };
      const render = t => {
        const [base,body,accent] = layers;
        ctx.clearRect(0,0,660,660); ctx.drawImage(base,0,0);
        const wave = Math.sin(Math.PI*t)**2;
        if (kind === 'breath') {
          for (let y=0;y<660;y+=2) {
            const chest = Math.exp(-Math.pow((y-365)/108,2));
            const scale = 1 + .08*wave*chest;
            ctx.drawImage(body,0,y,660,2,330-330*scale,y,660*scale,2.5);
          }
          ctx.globalAlpha = .65+.35*wave;
          ctx.drawImage(accent,-24*wave,0); ctx.globalAlpha=1;
        } else if (kind === 'foundation') {
          for (let y=0;y<660;y+=2) {
            const anchor = y<360?1:Math.max(0,(550-y)/190);
            const wide = 1+.05*wave*Math.exp(-Math.pow((y-420)/70,2));
            ctx.drawImage(body,0,y,660,2,330-330*wide,y+28*wave*anchor,660*wide,3);
          }
        } else if (kind === 'bounce') {
          const lift = Math.max(0,Math.sin(t*2*Math.PI*2))*38;
          const compression = Math.max(0,-Math.sin(t*2*Math.PI*2))*.065;
          ctx.save(); ctx.translate(330,535-lift); ctx.scale(1+compression*.4,1-compression);
          ctx.drawImage(body,-330,-535); ctx.restore();
        } else if (kind === 'control') {
          const shift=.035*Math.sin(t*Math.PI*2)*Math.sin(Math.PI*t);
          ctx.save(); ctx.transform(1,0,shift,1,-535*shift,0);
          ctx.drawImage(body,0,0); ctx.restore();
        } else {
          ctx.drawImage(body,0,0);
          for(let x=0;x<660;x+=2) {
            const amount=Math.max(0,(x-420)/240);
            const dy=24*amount*Math.sin(x*.024-t*Math.PI*6)*Math.sin(Math.PI*t);
            ctx.drawImage(accent,x,0,2,660,x,dy,2.5,660);
          }
        }
      };
      const play = async () => {
        if (disposed || active || !visible || paused || reduced.matches || document.hidden) return;
        active = true;
        const ticket = ++generation;
        try { await load(); } catch { if (ticket===generation) stop(); return; }
        if (ticket !== generation || disposed) return;
        if (!visible || paused || reduced.matches || document.hidden) { stop(); return; }
        stage.classList.add('is-playing'); stage.dataset.animating = 'true';
        const start = performance.now();
        const frame = now => {
          if (!active || disposed || !stage.isConnected || !visible || paused || reduced.matches || document.hidden) { stop(); return; }
          render(((now-start)/3400)%1); raf = requestAnimationFrame(frame);
        };
        raf = requestAnimationFrame(frame);
      };
      const sync = () => { stop(); play(); };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play(); else stop();
      }, {threshold:0});
      observer.observe(stage);
      controllers.push({sync,destroy(){ disposed=true; stop(); observer.disconnect(); canvas.remove(); }});
    });
    const sync = () => {
      if (toggle) {
        toggle.hidden = controllers.length === 0;
        toggle.disabled = reduced.matches;
        toggle.textContent = reduced.matches ? root.dataset.ppReduced : paused ? root.dataset.ppResume : root.dataset.ppPause;
        toggle.setAttribute('aria-pressed',String(paused));
      }
      controllers.forEach(controller => controller.sync());
    };
    const onClick = () => { paused=!paused; pauseState.set(key,paused); sync(); };
    if (toggle) toggle.addEventListener('click',onClick);
    roots.set(root,{sync,destroy(){
      controllers.forEach(controller=>controller.destroy());
      if (toggle) { toggle.removeEventListener('click',onClick); toggle.hidden=true; }
    }});
    sync();
  }
  function remove(root) {
    roots.get(root)?.destroy(); roots.delete(root);
    if (!roots.size) { clearInterval(preferenceTimer); preferenceTimer=undefined; }
  }
  function syncAll() {
    roots.forEach((controller,root)=>{ if (!root.isConnected) remove(root); else controller.sync(); });
  }
  function syncPreference() {
    if (document.hidden) return;
    roots.forEach((controller,root)=>{if(!root.isConnected)remove(root);});
    if (reduced.matches === lastReduced) return;
    lastReduced = reduced.matches; syncAll();
  }
  function scan(scope) {
    if (scope.matches?.('[data-tsh-pp-root]')) bind(scope);
    scope.querySelectorAll?.('[data-tsh-pp-root]').forEach(bind);
    if (roots.size && !preferenceTimer) preferenceTimer = setInterval(syncPreference,500);
  }
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    roots.forEach((controller,root)=>{if(event.target===root || event.target.contains(root))remove(root);});
  });
  document.addEventListener('shopify:section:reorder',event=>{scan(event.target); syncAll();});
  document.addEventListener('shopify:block:select',event=>{
    const band=event.target.closest?.('.tsh-pp-band');
    if (band?.closest('[data-tsh-pp-root]')) band.scrollIntoView({block:'center',behavior:'auto'});
  });
  reduced.addEventListener('change',syncPreference);
  document.addEventListener('visibilitychange',syncAll);
  window.TSHPillarsPage={scan};
  scan(document);
})();
